package com.iptvplayer.shared.domain.model

data class Playlist(
    val source: IptvSource,
    val channels: List<Channel>,
    val vodItems: List<VodItem>,
    val categories: List<String>,
    val series: List<SeriesItem> = emptyList()
)
